import type { IValueAndUnit } from '@/interfaces/IValueAndUnit'

class ValueAndUnit<T> implements IValueAndUnit<T> {
  value: T
  unit: string

  constructor(valueAndUnit?: any) {
    this.value = valueAndUnit?.value
    this.unit = valueAndUnit?.unit
  }
}

export default ValueAndUnit
